/**
 * Enum représentant le mode dans lequel on est lors de traitements sur la partie navette.
 */
export enum ModeNavette {
	// Mode spécifique à la gestion de navette
	GESTION = 'GESTION',

	// Mode spécifique à la réservation de navette
	RESERVATION = 'RESERVATION'
}